import { useRefinementList } from 'react-instantsearch'

import { FACETS } from './CollectionFiltersDrawer'

// This component ensures that refinement list widget is always mounted no matter if drawer is open/close (mounts/unmounts)
export const PersistentFacetWidgets = () => {
  return (
    <>
      {FACETS.map((facet) => (
        <HiddenFacet key={facet} attribute={facet} />
      ))}
    </>
  )
}

function HiddenFacet({ attribute }: { attribute: string }) {
  useRefinementList({ attribute })

  return null
}
